import { ANNUALLY, MONTHLY } from '@constants/billingPeriods'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Badge, Button, ButtonGroup, Spreader } from '@ui-kit'
import { useTranslation } from 'react-i18next'

export const BillingPeriodSwitcher = () => {
  const { t } = useTranslation()

  const { chosenBillingPeriod, setBillingPeriod } = useCheckoutContext()

  const buttons = [
    <Button variant='text-neutral' value={MONTHLY} data-testid='monthly-button'>
      {t('change.plan.page.pay.monthly')}
    </Button>,
    <Button
      variant='text-neutral'
      value={ANNUALLY}
      data-testid='annually-button'
    >
      {t('change.plan.page.pay.annually')}

      <Spreader spread={5} />

      <Badge variant='warning20-filled' weight={600} isTextUppercase>
        {t('checkout.annually.2.months.free')}
      </Badge>
    </Button>
  ]

  return (
    <ButtonGroup
      buttons={buttons}
      selected={chosenBillingPeriod}
      setSelected={setBillingPeriod}
    />
  )
}

BillingPeriodSwitcher.displayName = 'CheckoutPlansHeaderBillingPeriodSwitcher'
